export const ReferralPageEvent = {
  ReferralPageView: 'referral_page_view',
  ReferralPageBannerClick: 'referral_page_banner_click',
  ReferralPageBenefitClick: 'referral_page_referral_benefit_click',
  ReferralPageShareVipClick: 'referral_page_share_vip_click',
  ReferralPageViewMyReferralClick: 'referral_page_view_my_referral_click',
  ReferralViewExampleClick: 'referral_view_example_click',
  ReferralLearnMoreClick: 'referral_learn_more_click',
  ReferralCopyClick: 'referral_copy_click',
  ReferralShareClick: 'referral_share_click',
  ReferralDashboardView: 'referral_dashboard_page',
  ReferralDashboardReferralTabClick: 'referral_tab_click',
  ReferralDashboardClickCopyLink: 'referral_dashboard_page__click_copy_link',
  ReferralDashboardClickCopyCode: 'referral_dashboard_page__click_copy_code',
  ReferralDashboardClickChangeRewardsHistoryRange: 'referral_dashboard_page__click_change_rewards_history_range',
  ReferralDashboardClickChangeReferralHistoryRange: 'referral_dashboard_page__click_change_referral_history_range',
  ReferralPageLandingBannerView: 'referral_page_landing_banner_view',
  ReferralPageLandingBannerClick: 'referral_page_landing_banner_click',
  // referral progress visibility and nudging
  ReferralDashboardPageSocialRemindClick: 'referral_dashboard_page_social_remind_click',
  ReferralDashboardPageSocialViewPendingFriendsClick: 'referral_dashboard_page_social_view_pending_friends_click',
  ReferralDashboardPageSocialNudgeModalView: 'referral_dashboard_page_social_nudge_modal_view',
  ReferralDashboardPageSocialSendReminderClick: 'referral_dashboard_page_social_send_reminder_click',
  ReferralDashboardPageSocialNudgeMessageCopyClick: 'referral_dashboard_page_social_nudge_message_copy_click',
} as const;

export interface ReferralPageEventDataType {
  [ReferralPageEvent.ReferralDashboardView]: {
    nudge_friends: number;
  };
  [ReferralPageEvent.ReferralViewExampleClick]: {
    list_order: number;
  };
  [ReferralPageEvent.ReferralLearnMoreClick]: {
    refer_type: 'referrer' | 'referee';
  };
  [ReferralPageEvent.ReferralDashboardReferralTabClick]: {
    tab_type: string;
  };
  [ReferralPageEvent.ReferralDashboardClickChangeReferralHistoryRange]: {
    start_date: string;
    end_date: string;
  };
  [ReferralPageEvent.ReferralPageLandingBannerView]: {
    event_type: string;
  };
  [ReferralPageEvent.ReferralPageLandingBannerClick]: {
    event_type: string;
  };
  [ReferralPageEvent.ReferralPageView]: {
    reward_amount?: number;
  };
  [ReferralPageEvent.ReferralPageBannerClick]: {
    reward_amount?: number;
    banner_text: string;
  };
  // referral progress visibility and nudging
  [ReferralPageEvent.ReferralDashboardPageSocialRemindClick]: {};
  [ReferralPageEvent.ReferralDashboardPageSocialViewPendingFriendsClick]: {};
  [ReferralPageEvent.ReferralDashboardPageSocialNudgeModalView]: {
    modal_type: 'single_friend' | 'multiple_friends';
    num_friends_need_to_kyc: number;
    num_friends_need_to_deposit: number;
    num_friends_need_to_trade: number;
  };
  [ReferralPageEvent.ReferralDashboardPageSocialSendReminderClick]: {
    modal_type: 'single_friend' | 'multiple_friends';
    nudge_type: 'kyc' | 'deposit' | 'trade';
  };
  [ReferralPageEvent.ReferralDashboardPageSocialNudgeMessageCopyClick]: {
    modal_type: 'single_friend' | 'multiple_friends';
    nudge_type: 'kyc' | 'deposit' | 'trade';
  };
}
